<template>
  <div v-if="showTable">
    <div class="styleRow">
      <graph-container></graph-container>
      <notifications></notifications>
      <graph-times-container></graph-times-container>
    </div>
    <tasks-table></tasks-table>
    <!--    <div v-if="showTable">-->
    <!--      <TasksMainCalendar-->
    <!--          :query-object="queryObject"-->
    <!--          @due_date="setDueDate"-->
    <!--          @invoice_date="setInvoiceDate"-->
    <!--          @purchase_date="setDate"-->
    <!--          @resetOneCalendar="clearDates"-->
    <!--          @total_spent_by_date="setTotalSpentDate"-->
    <!--          @payment_method_info="setPaymentMethodsInfo"-->
    <!--      />-->
    <!--    </div>-->
    <div class="styleRow">
      <graph-button-times-container></graph-button-times-container>
      <notifications></notifications>
      <graph-tags-container></graph-tags-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import GraphContainer from "../sub_features.tasks/graph.sub_feature.tasks/containers/Graph.container";
import TasksTable from "../containers/TasksTable.container";
import Notifications from "../../msg_center.feature/containers/Notifications.component";
import GraphTagsContainer from "../sub_features.tasks/graph.sub_feature.tasks/containers/GraphTags.container";
import GraphTimesContainer from "../sub_features.tasks/graph.sub_feature.tasks/containers/GraphTimes.container";
import GraphButtonTimesContainer from "../sub_features.tasks/graph.sub_feature.tasks/containers/GraphBottomTimes.container";
import TasksMainCalendar from "../components/TasksMainCalendar";
import moment from "moment";
import apiClientCreator from "@/helpers/api/request";
export default {
  name: "tasks-container",

  components: {
    // TasksMainCalendar,
    TasksTable,
    Notifications,
    GraphContainer,
    GraphTagsContainer,
    GraphTimesContainer,
    GraphButtonTimesContainer
  },
  data() {
    return {
      showTable: false,
      queryObject: {
        page: 1
      }
    };
  },
  beforeMount() {
    this.$store.dispatch("clients/getGeneralDictionary").then(res => {
      this.$store.dispatch("tasks/getTaskDictionary").then(res => {
        this.$store.dispatch("clients/getSalesPersonList").then(res => {
          this.showTable = true;
        });
      });
    });
  },

  methods: {
    // setDueDate(data) {
    //   this.queryObject = {};
    //   this.queryObject = Object.assign({}, this.queryObject, {
    //     due_date_from: moment(data.date.start).format("YYYY-MM-DD"),
    //     due_date_at: moment(data.date.end).format("YYYY-MM-DD")
    //   });
    //   this.getList();
    // },
    // async getList() {
    //   this.$store.commit("clients/setLoading", true);
    //
    //   let getFinanceList = apiClientCreator("finance/list");
    //   let result = await getFinanceList.get("", { params: this.queryObject });
    //   this.pagination.currentPage = result.data.current_page;
    //   this.pagination.perPage = result.data.per_page;
    //   this.pagination.total = result.data.total;
    //   this.pagination.lastPage = result.data.last_page;
    //   this.pagination.to = result.data.to;
    //   this.pagination.from = result.data.from;
    //
    //   let financeData = [];
    //   result.data.data.forEach(finance => {
    //     financeData.push(new FinanceModel(finance));
    //   });
    //   this.financeData = financeData;
    //   this.calcTotals(result.data.data);
    //   this.getTotalAmount();
    //   this.$store.commit("clients/setLoading", false);
    // },
  },

  computed: {
    ...mapActions("clients", [
      "getActivityDictionary",
      "getGeneralDictionary",
      "getSalesPersonList"
    ])
  }
};
</script>

<style lang="scss" scoped>
html * {
  font-family: "Segoe UI", Arial, sans-serif !important;
}

.leads-time-frame-row {
  margin-bottom: 10px;
}
.table {
  height: 180px;
  width: 100%;
}
.ai-window {
  position: absolute;
  left: 150px;
  width: 180px;
}
.clients-table {
  margin-top: 3px;
  margin-left: -10px;
  margin-right: 5px;
  margin-bottom: -12px;
  z-index: 2;
  position: absolute;
}
.graph-container {
  margin-left: -10px;
  margin-right: -163px;
}
.notifications {
  margin-left: 0px;
  margin-right: -10px;
  width: 100%;
  z-index: 2;
  position: absolute;
}
.card-bottom {
  height: 100%;
}
.bottom-cam {
  height: 240px;
  margin-top: 460px;
  margin-left: -12px;
  margin-right: -10px;
  margin-bottom: -12px;
}
.bottom-chat {
  height: 240px;
  margin-top: 460px;
  margin-left: -10px;
  margin-right: -12px;
  margin-bottom: -12px;
}
.styleRow {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
</style>
